<div class="row columns summary-wrapper" *ngIf="hasShopSummary && (step === 'payment' || step === 'payment-select')">
    <div class="summary">
        <h2>{{'shop.summary.headline' | translate}}</h2>
        <div class="row summary-table-header">
            <div class="columns medium-1">&nbsp;</div>
            <div class="columns medium-5">{{'shop.cart.items.product' | translate}}</div>
            <div class="columns medium-2 align-right">{{'shop.cart.items.count' | translate}}</div>
            <div class="columns medium-4 large-2 align-right">{{'shop.cart.items.price' | translate}}</div>
            <div class="columns large-2 align-right show-for-large">{{'shop.cart.items.sum' | translate}}</div>
        </div>
        <div class="row summary-item" *ngFor="let item of itemsWithoutOptionalDonation">
            <div class="columns medium-1">
                <img *ngIf="item.product.images && item.product.images.length > 0" [src]="getProuctImage(item.product)"
                    [alt]="item.product.name">
                <span *ngIf="!item.product.images || item.product.images.length === 0">&nbsp;</span>
            </div>
            <div class="columns medium-5 summary-item-description">
                <h4 [innerHTML]="item.product.name"></h4>
                <span *ngIf="item.product.description" [innerHTML]="item.product.description | nl2br"></span>
                <span *ngIf="item.text">{{'shop.item.textinput.placeholder' | translate}}: {{item.text}}</span>
            </div>
            <div class="columns medium-2 align-right">
                <span class="hide-for-medium">{{'shop.cart.items.count' | translate}}: </span>{{item.count}}
            </div>
            <div class="columns medium-4">
                <div class="row">
                    <div class="columns medium-12 large-6 align-right">
                        <span class="hide-for-medium">{{'shop.cart.items.price' | translate}}: </span>
                        {{item.getPrice() | number: '1.2-2'}} {{donation.currencySymbol}}
                    </div>
                    <div class="columns medium-12 large-6 align-right">
                        <span class="show-for-medium-only">{{'shop.cart.items.sum' | translate}}: </span>
                        <strong>
                            {{(item.getPrice() * item.count) | number: '1.2-2'}}
                            {{donation.currencySymbol}}
                        </strong>
                    </div>
                </div>
            </div>
        </div>
        <div class="row summary-price">
            <div class="columns hide-for-small-only medium-5 large-7">&nbsp;</div>
            <div class="columns small-8 medium-5 large-3">{{'shop.summary.subtotal' | translate}}</div>
            <div class="columns small-4 medium-2 align-right"> {{this.totalPrice | number: '1.2-2'}}
                {{donation.currencySymbol}}
            </div>
        </div>
        <div class="row summary-price" *ngIf="giftCount >= 1">
            <div class="columns hide-for-small-only medium-5 large-7">&nbsp;</div>
            <div class="columns small-8 medium-5 large-3">{{'shop.summary.gift.count' | translate}}</div>
            <div class="columns small-4 medium-2 align-right"> {{giftCount}} x</div>
        </div>
        <div class="row summary-price" *ngIf="this.optionalDonationPrice">
            <div class="columns hide-for-small-only medium-5 large-7">&nbsp;</div>
            <div class="columns small-8 medium-5 large-3">{{'shop.summary.brochure.donation' | translate}}</div>
            <div class="columns small-4 medium-2 align-right"> {{this.optionalDonationPrice | number: '1.2-2'}}
                {{donation.currencySymbol}} </div>
        </div>
        <div class="row summary-price" *ngIf="this.donation.extraAmount">
            <div class="columns hide-for-small-only medium-5 large-7">&nbsp;</div>
            <div class="columns small-8 medium-5 large-3">{{'shop.summary.topup' | translate}}</div>
            <div class="columns small-4 medium-2 align-right"> {{this.donation.extraAmount | number: '1.2-2'}}
                {{donation.currencySymbol}} </div>
        </div>
        <div class="row summary-price summary-total">
            <div class="columns hide-for-small-only medium-5 large-7">&nbsp;</div>
            <div class="columns small-8 medium-5 large-3">{{'shop.summary.sum' | translate}}</div>
            <div class="columns small-4 medium-2 align-right"> {{this.donation.amount + this.donation.extraAmount |
                number:
                '1.2-2'}}
                {{donation.currencySymbol}} </div>
        </div>
    </div>

    <div *ngIf="hasPolicy" class="summary-policy" [innerHTML]="'shop.summary.policy' | translate"></div>

		<div *ngIf="hasTerms" class="summary-terms" [formGroup]="form">
			<p class="formfield-error" *ngIf="form.controls.summary_terms.touched === true && form.controls.summary_terms.valid === false" [innerHTML]="'shop.summary.terms.error' | translate"></p>
			<div class="checkboxbutton-wrapper">
				<input type="checkbox" id="termsCheckbox" [(ngModel)]="donation.additional.shop_term" formControlName="summary_terms">
				<label [innerHTML]="'shop.summary.terms' | translate" for="termsCheckbox"></label>
			</div>
		</div>

</div>
